/**
 * @friskai/frisk-js Options Utilities
 *
 * Helpers for normalizing and validating Frisk redaction options.
 */

export type RedactionPolicy = boolean | string[]

/**
 * Options for initializing the Frisk SDK
 */
export interface RedactionOptions {
  /**
   * Redaction configuration for tool arguments.
   * - `true`: Redact all fields in tool arguments
   * - `false`: Do not redact any fields
   * - `string[]`: Array of field names to selectively redact
   */
  redactToolArgs?: RedactionPolicy

  /**
   * Redaction configuration for agent state.
   * - `true`: Redact all fields in agent state
   * - `false`: Do not redact any fields
   * - `string[]`: Array of field names to selectively redact
   */
  redactAgentState?: RedactionPolicy
}

/**
 * Normalized redaction options with defaults applied
 */
export interface ResolvedRedactionOptions {
  redactToolArgs: RedactionPolicy
  redactAgentState: RedactionPolicy
}

/**
 * Normalize redaction options with defaults
 */
export function resolveRedactionOptions(
  options?: RedactionOptions,
): ResolvedRedactionOptions {
  return {
    redactToolArgs: options?.redactToolArgs ?? false,
    redactAgentState: options?.redactAgentState ?? false,
  }
}
